import script from "./GroupUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./GroupUpsert.vue?vue&type=style&index=0&id=2e98a8bc&lang=scss"

const __exports__ = script;

export default __exports__